module.exports = "<app-paragraphs [paragraphs]=\"data?.content\"></app-paragraphs>\n\n<button mat-button (click)=\"next()\">Další</button>\n"